"use client"

import { FileBadge } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `FileBadgeIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const FileBadgeIcon = component(Icon)({ as: FileBadge })
